import React from 'react';

export default function CBXLogo({ width = 76, height = 44 }) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 384.455 142.371">
      <g id="Group_203" data-name="Group 203" transform="translate(-0.127 -0.001)">
        <g id="Group_160" data-name="Group 160" transform="translate(0.127 0.001)">
          <path
            id="Path_23"
            data-name="Path 23"
            d="M201.043,94.121l-15.1-15.557c-8.472,7.857-16.021,12.885-28.342,12.885-18.486,0-31.272-15.712-31.272-34.568v-.314c0-18.856,13.1-34.253,31.272-34.253,10.781,0,19.255,4.713,27.572,12.412l15.1-17.757C190.26,6.915,178.089,0,157.757,0c-33.117,0-56.222,25.612-56.222,56.881V57.2c0,26.592,16.743,48.441,40.969,54.7,15.514-3.421,31.78-6.337,48.562-8.671a72.269,72.269,0,0,0,9.977-9.106"
            transform="translate(-62.955 0)"
            fill="#272031"
          />
          <path
            id="Path_24"
            data-name="Path 24"
            d="M441.442,93.641H413.258v-24.2h27.416c12.169,0,17.562,4.552,17.562,11.942V81.7c0,8.175-6.314,11.945-16.793,11.945M413.258,26.076h23.409c10.014,0,15.558,4.088,15.558,11.316V37.7c0,8.172-6.622,11.624-17.1,11.624h-21.87Zm63.51,73.43c3.071-2.082,11.631-33.49-14.37-40.266,7.7-4.4,13.4-13.21,13.4-25.62V33.3a25.492,25.492,0,0,0-7.4-18.7c-6.157-6.284-15.866-9.74-28.188-9.74H390.146v98.586a680.186,680.186,0,0,1,86.622-3.946"
            transform="translate(-239.576 -2.978)"
            fill="#272031"
          />
          <path
            id="Path_25"
            data-name="Path 25"
            d="M668.866,101.931l16-24.79,18.659,29.1q17.229,2.8,31.932,6.638L699.2,59.367l36.032-54.5H708.28L685.325,40.535,662.838,4.866H635.113L671.171,59.68,643.4,100.231c4.344.2,8.683.4,12.992.691,4.25.285,8.373.642,12.478,1.009"
            transform="translate(-389.488 -2.978)"
            fill="#272031"
          />
          <path
            id="Path_26"
            data-name="Path 26"
            d="M386.564,295.727C250.623,242.214,58.729,284.278,2.109,307.449H70.917c50.552-13.755,190.708-32.33,315.647-11.722"
            transform="translate(-2.109 -165.079)"
            fill="#272031"
          />
          <path
            id="Path_27"
            data-name="Path 27"
            d="M386.564,295.727C250.623,242.214,58.729,284.278,2.109,307.449H70.917c50.552-13.755,190.708-32.33,315.647-11.722"
            transform="translate(-2.109 -165.079)"
            fill="#de69a1"
          />
        </g>
      </g>
    </svg>
  );
}
